import { render, staticRenderFns } from "./PointDetail.vue?vue&type=template&id=bd8e2fae&scoped=true&"
import script from "./PointDetail.vue?vue&type=script&lang=js&"
export * from "./PointDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8e2fae",
  null
  
)

export default component.exports